<app-page-title
	[title]="deadName"
	[subtitle]="deadSub"
	[breadcrumb]="deadName"
	(subpageClick)="nav.goObituary()"
	subpage="Obituário"
	[loading]="loading"
	/>

<section class="container dead-section">

	<app-big-loader *ngIf="loading" />
	<app-dead-view *ngIf="death" class="view" [dead]="death" />
	<app-error-box *ngIf="errorBox" errorMsg="Não foi possível encontrar este presunto!" />
	
</section>


